export default __webpack_public_path__ + "static/media/van_dark.d934ce04.png";